module.exports = __webpack_public_path__ + "img/CD-ROM.eaf47af3.png";